

export enum MenuBarCodebooksEnum {
    users = 'Korisnici',
    roles = 'Role',
   // productCategories = 'Kategorije proizvoda',
    //product = 'Proizvod',
    vehicleModel='Model',
    brand='Brend',
    vehicle='Vozila',
    travelOrder='Putni nalog',
  }